import { render, staticRenderFns } from "./yetitle.vue?vue&type=template&id=2358f55d&scoped=true&"
import script from "./yetitle.vue?vue&type=script&lang=js&"
export * from "./yetitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2358f55d",
  null
  
)

export default component.exports